var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubheaderDsp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14V17",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14V17",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14V17",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14V17",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 14V17",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 14V17",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37 14V17",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39V42",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39V42",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39V42",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39V42",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31 39V42",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34 39V42",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37 39V42",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.618 30.37H21.77C22.556 30.37 23.156 30.154 23.57 29.722C23.984 29.29 24.191 28.687 24.191 27.913C24.191 27.139 23.984 26.536 23.57 26.104C23.156 25.672 22.556 25.456 21.77 25.456H20.618V30.37ZM21.77 24.763C22.778 24.763 23.573 25.045 24.155 25.609C24.737 26.173 25.028 26.941 25.028 27.913C25.028 28.885 24.737 29.644 24.155 30.19C23.573 30.73 22.778 31 21.77 31H19.799V24.763H21.77ZM26.7316 26.428C26.7316 26.656 26.7946 26.845 26.9206 26.995C27.0466 27.145 27.2086 27.256 27.4066 27.328C27.6046 27.4 27.8236 27.463 28.0636 27.517C28.3096 27.571 28.5526 27.634 28.7926 27.706C29.0386 27.772 29.2606 27.859 29.4586 27.967C29.6566 28.075 29.8186 28.237 29.9446 28.453C30.0706 28.669 30.1336 28.936 30.1336 29.254C30.1336 29.74 29.9476 30.163 29.5756 30.523C29.2036 30.883 28.6996 31.063 28.0636 31.063C27.4336 31.063 26.9206 30.919 26.5246 30.631C26.1286 30.337 25.9306 29.941 25.9306 29.443H26.8036C26.8276 29.725 26.9386 29.953 27.1366 30.127C27.3406 30.301 27.6406 30.388 28.0366 30.388C28.4326 30.388 28.7476 30.286 28.9816 30.082C29.2156 29.878 29.3326 29.641 29.3326 29.371C29.3326 29.095 29.2696 28.885 29.1436 28.741C29.0176 28.591 28.8556 28.48 28.6576 28.408C28.4596 28.336 28.2376 28.276 27.9916 28.228C27.7516 28.174 27.5086 28.111 27.2626 28.039C27.0226 27.967 26.8036 27.877 26.6056 27.769C26.4076 27.655 26.2456 27.49 26.1196 27.274C25.9936 27.052 25.9306 26.779 25.9306 26.455C25.9306 25.927 26.1166 25.504 26.4886 25.186C26.8666 24.862 27.3556 24.7 27.9556 24.7C28.5616 24.7 29.0416 24.841 29.3956 25.123C29.7556 25.399 29.9626 25.783 30.0166 26.275H29.1076C29.0836 26.029 28.9666 25.819 28.7566 25.645C28.5526 25.471 28.2736 25.384 27.9196 25.384C27.5716 25.384 27.2866 25.474 27.0646 25.654C26.8426 25.828 26.7316 26.086 26.7316 26.428ZM33.3729 24.763C34.0749 24.763 34.6089 24.934 34.9749 25.276C35.3469 25.618 35.5329 26.056 35.5329 26.59C35.5329 27.124 35.3529 27.565 34.9929 27.913C34.6389 28.255 34.0989 28.426 33.3729 28.426H32.1669V31H31.3479V24.763H33.3729ZM32.1669 27.778H33.3729C33.8229 27.778 34.1559 27.676 34.3719 27.472C34.5939 27.262 34.7049 26.971 34.7049 26.599C34.7049 25.813 34.2609 25.42 33.3729 25.42H32.1669V27.778Z",
    fill: "#4F7FA7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42 19L39 19",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22L39 22",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42 25L39 25",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42 28L39 28",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31L39 31",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34L39 34",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42 37L39 37",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L14 19",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L14 22",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25L14 25",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28L14 28",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31L14 31",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17 34L14 34",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17 37L14 37",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 22,
    height: 22,
    rx: 2,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubheaderDsp);
export default __webpack_public_path__ + "static/media/subheader-DSP.6d431993c829d04002fc1c9857fdd666.svg";
export { ForwardRef as ReactComponent };